import { ContentCopy } from "@mui/icons-material";
import { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { Log } from "@ryde/shared";

import { FramerTooltip } from "../tooltips/framer-tooltip";
import {
  AuditLogTraceIdBadgeStyled,
  AuditLogTraceIdCopyButtonStyled,
} from "./audit-log-metadata-labels.styled";

interface IAuditLogTraceIdBadgeProps {
  traceId: string;
}

export const AuditLogTraceIdBadge: FC<IAuditLogTraceIdBadgeProps> = ({
  traceId,
}) => {
  const { t } = useTranslation();
  const traceIdLabel = t("auditLog.traceIdLabel");
  const fullTraceIdText = `${traceIdLabel}: ${traceId}`;

  const handleCopyClick = useEvent(
    async (event: MouseEvent<HTMLButtonElement>): Promise<void> => {
      event.preventDefault();
      event.stopPropagation();

      await navigator.clipboard.writeText(traceId);
      Log.infoAndToast(t("auditLog.traceIdCopiedToClipboard"));
    },
  );

  return (
    <AuditLogTraceIdBadgeStyled>
      <FramerTooltip content={fullTraceIdText}>
        <span className="audit-log-trace-id-badge__text">
          <span className="audit-log-trace-id-badge__label">
            {traceIdLabel}:
          </span>
          <span className="audit-log-trace-id-badge__value">{traceId}</span>
        </span>
      </FramerTooltip>
      <AuditLogTraceIdCopyButtonStyled
        size="small"
        aria-label={t("auditLog.copyTraceId")}
        onClick={handleCopyClick}
      >
        <ContentCopy />
      </AuditLogTraceIdCopyButtonStyled>
    </AuditLogTraceIdBadgeStyled>
  );
};
